import { useNavigate } from 'react-router';
import { Link } from '#components/atoms/link/Link.tsx';
import { MainLayout } from '#components/patterns/layouts/main/MainLayout.tsx';
import { PageCloser } from '#components/patterns/page-closer/PageCloser.tsx';
import { PageHeader } from '#components/patterns/page-header/PageHeader.tsx';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { fromArray, Titled } from '#util/title.ts';
import { NetworkForm } from '../form/NetworkForm.tsx';
import { NetworksPage } from '../list/NetworksPage.tsx';
import { TooManyNetworksModal } from './TooManyNetworksModal.tsx';
import { useSuspenseIsNetworkLimitReached } from './useSuspenseIsNetworkLimitReached.ts';

/**
 * Shows a form for adding a network (after first one has been created with the get-started wizard)
 */
export function AddNetworkPage() {
  const navigate = useNavigate();
  const location = useAppLocation();
  const from = location.state?.from;
  const { isNetworkLimitReached, networkLimit } = useSuspenseIsNetworkLimitReached();

  function returnToList() {
    void navigate(from ?? '/settings/networks');
  }

  return (
    <Titled title={(title) => fromArray(['Add', title])}>
      {isNetworkLimitReached ?
        <>
          <NetworksPage />
          <TooManyNetworksModal onClose={returnToList} networkLimit={networkLimit} />
        </>
      : <MainLayout
          header={
            <PageHeader
              title={
                <>
                  <Link to="/settings/networks" className="a">
                    Networks
                  </Link>
                  {' / '}
                  Add
                </>
              }
            >
              <PageCloser fallbackTo="/settings/networks" />
            </PageHeader>
          }
        >
          <NetworkForm networkId={null} onSuccess={returnToList} />
        </MainLayout>
      }
    </Titled>
  );
}
